import Vue from "vue";
import Router from "vue-router";
import multiguard from "vue-router-multiguard";

// Custom Components
import AuthRegister from "@/components/Auth/Register";
import AuthLogin from "@/components/Auth/Login";
import Landing from "@/components/Pages/Landing";
import Terms from "@/components/Pages/Terms";
import Dashboard from "@/components/Pages/Dashboard";
import About from "@/components/Pages/About/About";
import Style from "@/components/Pages/Style/Style.vue";
import ProfileView from "@/components/Pages/Profile/View";
import ProfileEdit from "@/components/Pages/Profile/Edit";
// import GroupIndex from '@/components/Pages/Group/Index';
import GroupCreate from "@/components/Pages/Group/Create";
import GroupEdit from "@/components/Pages/Group/Edit";
import GroupMembers from "@/components/Pages/Group/Members";
import GroupMembersImport from "@/components/Pages/Group/MembersImport";
import GroupAdministrators from "@/components/Pages/Group/Administrators";
import GroupView from "@/components/Pages/Group/View";
import GroupFind from "@/components/Pages/Group/Find";
import GroupFileManager from "@/components/Pages/Group/FileManager";
import Coaching from "@/components/Pages/About/Coaching";
import MicroCredentials from "@/components/Pages/About/MicroCredentials";
import ProfessionalDevelopment from "@/components/Pages/About/ProfessionalDevelopment";
import SchoolMarketing from "@/components/Pages/About/SchoolMarketing";
import AuthForgotPassword from "@/components/Auth/ForgotPassword";
import AuthResetPassword from "@/components/Auth/ResetPassword";
import AuthResetSuccessful from "@/components/Auth/ResetSuccessful";
import AuthMissingToken from "@/components/Auth/MissingToken";
import UserfileView from "@/components/Pages/Userfile/View";
import UserfileDownload from "@/components/Pages/Userfile/Download";
import FeedbackForm from "@/components/Pages/Feedback/Create";
import TrainingModuleView from "@/components/Pages/TrainingModule/View";
import TrainingModuleCreate from "@/components/Pages/TrainingModule/Create";
import TrainingModuleEdit from "@/components/Pages/TrainingModule/Edit";

import LayoutLogin from "@/components/Layouts/Login";
// import LayoutDefault from '@/components/Layouts/Default';
import LayoutMaterial from "@/components/Layouts/Material";
import LayoutEducationServices from "@/components/Layouts/EducationServices";

// import ProfileIndex from '@/components/Profile/ProfileView';

import NewDiscussion from "@/components/Pages/Cards/NewDiscussion";
import EditDiscussion from "@/components/Pages/Cards/EditDiscussion";
import NewResource from "@/components/Pages/Cards/NewResource";
import EditResource from "@/components/Pages/Cards/EditResource";
import NewClassroomObservation from "@/components/Pages/Cards/NewClassroomObservation";
import NewCoachingPlan from "@/components/Pages/Cards/NewCoachingPlan";
import DSECIndex from "@/components/Pages/DSEC/Index";

// registration pages
import EventTerms from "@/components/Pages/Events/Terms";
import ShortEventTerms from "@/components/Pages/Events/ShortTerms";
import EventCheckin from "@/components/Pages/Events/Checkin";
import EventMissingToken from "@/components/Pages/Events/MissingToken";

// Event custom registration pages.
import EventWithSessionOptions from "@/components/Pages/Events/Custom/EventWithSessionOptions";
import EventVirtual from "@/components/Pages/Events/Custom/ECNVirtual";
import EventWithSessionOptionsAndDietaryRestrictions from "@/components/Pages/Events/Custom/EventWithSessionOptionsAndDietaryRestrictions";
import DietaryRestrictionsCustom from "@/components/Pages/Events/Custom/DietaryRestrictionsCustom";
import EventTextOnly from "@/components/Pages/Events/Custom/EventTextOnly";
import EventCoP from "@/components/Pages/Events/Custom/EventCoP";
import TextBasedRole from "@/components/Pages/Events/Custom/TextBasedRole";

import EventTermsECS2023 from "@/components/Pages/Events/Custom/EarlyCollegeSummit2023Terms";
import ECNStudentLeaderNetworking from "@/components/Pages/Events/Custom/ECNStudentLeaderNetworking";
import ECN2024StudentGameChangerCareerPanel from "@/components/Pages/Events/Custom/ECN2024StudentGameChangerCareerPanel";
import EventEarlyCollegeSummit2024 from "@/components/Pages/Events/Custom/EarlyCollegeSummit2024";
import EarlyCollegeSummit2024RFP from "@/components/Pages/Events/Custom/EarlyCollegeSummit2024RFP";
import EarlyCollegeSummit2024StudentSpeaker from "@/components/Pages/Events/Custom/EarlyCollegeSummit2024StudentSpeaker";
import EarlyCollegeSummitSponsorshipPortal2025 from "@/components/Pages/Networks/Custom/EarlyCollegeSummitSponsorshipPortal2025";
import EarlyCollegeSummitSponsorshipPortal2025Terms from "@/components/Pages/Networks/Custom/EarlyCollegeSummitSponsorshipPortal2025Terms";
import EarlyCollegeSummitSponsorshipPortal2026 from "@/components/Pages/Networks/Custom/EarlyCollegeSummitSponsorshipPortal2026";
import EarlyCollegeSummitSponsorshipPortal2026Terms from "@/components/Pages/Networks/Custom/EarlyCollegeSummitSponsorshipPortal2026Terms";

import ECNInnovativePracticeCustom from "@/components/Pages/Events/Custom/ECNInnovativePracticeCustom";
import SELSummit2024 from "@/components/Pages/Events/Custom/SELSummit2024";

import NewTeacherInstitute from "@/components/Pages/Events/Custom/NewTeacherInstitute";
import NewTeacherInstituteTerms from "@/components/Pages/Events/Custom/NewTeacherInstituteTerms";

import PreConferenceStudyVisit2024 from "@/components/Pages/Events/Custom/PreConferenceStudyVisit2024";
import PreConferenceStudyVisitTerms2024 from "@/components/Pages/Events/Custom/PreConferenceStudyVisit2024Terms";

import PreConferenceStudyVisit2025 from "@/components/Pages/Events/Custom/PreConferenceStudyVisit2025";
import PreConferenceStudyVisitTerms2025 from "@/components/Pages/Events/Custom/PreConferenceStudyVisit2025Terms";

import EarlyCollegeSummit2023RFP from "@/components/Pages/Events/Custom/EarlyCollegeSummit2023RFP";
import EarlyCollegeSummit2023StudentSpeaker from "@/components/Pages/Events/Custom/EarlyCollegeSummit2023StudentSpeaker";
import EventTermsECS2022 from "@/components/Pages/Events/Custom/TermsAMAZSD69ECS2022";
import EventTermsIPGSummerInstitute2022 from "@/components/Pages/Events/Custom/TermsAMAZSD106IPGSummerInstitute2022";

import ALPS2023 from "@/components/Pages/Events/Custom/ALPS2023";
import ALPS2021AMAZSD82 from "@/components/Pages/Events/Custom/ALPS2021AMAZSD82";
import RethinkEducationSummerNetworking2022 from "@/components/Pages/Events/Custom/RethinkEducationSummerNetworking2022";
import RethinkEducationSummerSymposiumPreNetworking2022AMAZSD108 from "@/components/Pages/Events/Custom/RethinkEducationSummerSymposiumPreNetworking2022AMAZSD108";
import NCECSHSStudyVisitAMAZSD133 from "@/components/Pages/Events/Custom/NCECSHSStudyVisitAMAZSD133";
import TermsAMAZSD133 from "@/components/Pages/Events/Custom/TermsAMAZSD133";

// For ECN 2021 - 2022 Event custom registration pages.
import ECN2022CareerPanel from "@/components/Pages/Events/Custom/ECN2022CareerPanel";
import ECNInPersonEvents2021 from "@/components/Pages/Events/Custom/ECNInPersonEvents2021";
import STEMNetwork2024 from "@/components/Pages/Networks/Custom/STEMNetwork2024";

import RTILiteracySummit2023 from "@/components/Pages/Events/Custom/RTILiteracySummit2023";

// Database Driven Dynamic Event
import Event from "@/components/Pages/Events/Event";
import EventsList from "@/components/Pages/Events/List";

// Network Registrations.
import Network from "@/components/Pages/Networks/Network";
import NetworkAspireTeacherPrep2023 from "@/components/Pages/Networks/Custom/AspireTeacherPrep2023";
import NetworkAspireTeacherPrep2020 from "@/components/Pages/Networks/Archived/AspireTeacherPrep2020";
import NCLDMathScienceCollaborative2021 from "@/components/Pages/Networks/Custom/NCLDMathScienceCollaborative2021";
import NCLDMathScienceCollaborative2022 from "@/components/Pages/Networks/Custom/NCLDMathScienceCollaborative2022";
import NCLDC2022 from "@/components/Pages/Networks/Custom/NCLDC2022";
import NCLDC2023 from "@/components/Pages/Networks/Custom/NCLDC2023";
import NCLDC2024 from "@/components/Pages/Networks/Custom/NCLDC2024";
import NCLDC2025 from "@/components/Pages/Networks/Custom/NCLDC2025";
import NCLDC2026 from "@/components/Pages/Networks/Custom/NCLDC2026";
import SharedCheckin from "@/components/Pages/Networks/SharedCheckin";
import ECN2023 from "@/components/Pages/Networks/Custom/ECN2023";
import ECN2024 from "@/components/Pages/Networks/Custom/ECN2024";
import ECN2025 from "@/components/Pages/Networks/Custom/ECN2025";
import ECN2026 from "@/components/Pages/Networks/Custom/ECN2026";
import NationalECN2024 from "@/components/Pages/Networks/Custom/NationalECN2024";
import NationalECLN2026 from "@/components/Pages/Networks/Custom/NationalECLN2026";
import ECNHalfYear2024 from "@/components/Pages/Networks/Custom/ECNHalfYear2024";
import ECNHalfYear2025 from "@/components/Pages/Networks/Custom/ECNHalfYear2025";
import ECNHalfYear2026 from "@/components/Pages/Networks/Custom/ECNHalfYear2026";
import MSDLN2023 from "@/components/Pages/Networks/Custom/MSDLN2023";
import MSDLN2024 from "@/components/Pages/Networks/Custom/MSDLN2024";
import MSDLN2025 from "@/components/Pages/Networks/Custom/MSDLN2025";
import MSDLN2026 from "@/components/Pages/Networks/Custom/MSDLN2026";
import LLIN2026 from "@/components/Pages/Networks/Custom/LLIN2026";

// Error pages
import error403 from "@/components/Error/error403";
import error404 from "@/components/Error/error404";
import error500 from "@/components/Error/error500";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: __dirname,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    // authentication
    {
      path: "",
      component: LayoutLogin,
      children: [
        {
          path: "/terms",
          component: Terms,
          meta: {
            auth: true
          }
        },
        {
          path: "/",
          name: "Login",
          component: AuthLogin,
          beforeEnter: (to, from, next) => {
            if (Vue.auth.check()) {
              next("/dashboard");
            } else {
              next();
            }
          }
        },
        {
          path: "/reset-password",
          name: "Reset Password",
          component: AuthResetPassword,
          meta: {
            auth: false
          }
        },
        {
          path: "/forgot-password",
          name: "Forgot Password",
          component: AuthForgotPassword,
          meta: {
            auth: false
          }
        },
        {
          path: "/reset-successful",
          name: "Reset Successful",
          component: AuthResetSuccessful,
          meta: {
            auth: false
          }
        },
        {
          path: "/register",
          name: "Sign-Up",
          component: AuthRegister,
          meta: {
            auth: false
          }
        },
        {
          path: "/missing-token",
          name: "Missing Token",
          component: AuthMissingToken,
          meta: {
            auth: false
          }
        }
      ]
    },
    {
      path: "",
      component: LayoutMaterial,
      children: [
        {
          path: "/style",
          component: Style,
          meta: {
            auth: true
          }
        },
        {
          path: "/coaching",
          component: Coaching
        },
        {
          path: "/landing",
          component: Landing
        },
        {
          path: "/about",
          component: About
        },
        // {
        //   path: '/terms',
        //   component: Terms,
        //   meta: {
        //     auth: true
        //   }
        // },
        {
          path: "/dashboard",
          component: Dashboard,
          meta: {
            auth: true
          }
        },
        {
          path: "/profile/edit",
          component: ProfileEdit,
          meta: {
            auth: true
          }
        },
        {
          path: "/profile/:id?",
          component: ProfileView,
          meta: {
            auth: true
          }
        },
        {
          path: "/micro-credentials",
          name: "Micro Credentials",
          component: MicroCredentials,
          meta: {
            auth: false
          }
        },
        {
          path: "/professional-development",
          component: ProfessionalDevelopment,
          meta: {
            auth: false
          }
        },
        {
          path: "/school-marketing",
          component: SchoolMarketing,
          meta: {
            auth: false
          }
        },
        {
          path: "/group/create",
          components: {
            dialogContent: GroupCreate
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/find",
          components: {
            dialogContent: GroupFind
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/edit/:id",
          component: GroupEdit,
          meta: {
            auth: true
          }
        },
        {
          path: "/group/members/:id",
          components: {
            dialogContent: GroupMembers
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/administrators/:id",
          components: {
            dialogContent: GroupAdministrators
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/:id/file_manager",
          component: GroupFileManager,
          meta: {
            auth: true
          }
        },
        {
          path: "/feedback/create",
          components: {
            dialogContent: FeedbackForm
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/:id/card/:cardId",
          component: GroupView,
          meta: {
            auth: true
          }
        },
        {
          path: "/group/:id",
          component: GroupView,
          meta: {
            auth: true
          }
        },
        {
          path: "/group/members/import/:id",
          component: GroupMembersImport,
          meta: {
            auth: true
          }
        },

        // cards
        {
          path: "/group/new-discussion-card/:id",
          components: {
            dialogContent: NewDiscussion
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/edit-discussion-card/:id/:card_id",
          components: {
            dialogContent: EditDiscussion
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/new-resource-card/:id",
          components: {
            dialogContent: NewResource
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/edit-resource-card/:id/:card_id",
          components: {
            dialogContent: EditResource
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/new-observation-card/:id",
          components: {
            dialogContent: NewClassroomObservation
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/group/new-coaching-plan-card/:id",
          components: {
            dialogContent: NewCoachingPlan
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/userfile/view/:id",
          components: {
            dialogContent: UserfileView
          },
          meta: {
            auth: true,
            showDialog: true
          }
        },
        {
          path: "/resource/download",
          component: UserfileDownload,
          meta: {
            auth: true
          }
        },
        // training modules
        {
          path: "/module/create",
          component: TrainingModuleCreate,
          meta: {
            auth: true
          }
        },
        {
          path: "/module/edit/:id",
          component: TrainingModuleEdit,
          meta: {
            auth: true
          }
        },
        {
          path: "/module/:id",
          component: TrainingModuleView,
          meta: {
            auth: true
          }
        },
        {
          path: "/dsec",
          component: DSECIndex,
          meta: {
            auth: true
          }
        },
        {
          path: "/logout",
          beforeEnter: (to, from, next) => {
            Vue.auth.logout({
              redirect: "/"
            });
            next("/");
          }
        }
      ]
    },
    // registrations
    {
      path: "",
      component: LayoutEducationServices,
      children: [
        {
          path: "/event/extterms/:uuid",
          component: ShortEventTerms
        },
        {
          path: "/event/terms/:uuid",
          component: EventTerms
        },
        {
          path: "/event/ecs2022/terms/:uuid",
          component: EventTermsECS2022
        },
        {
          path: "/event/NC-visit/terms/:uuid",
          component: TermsAMAZSD133
        },
        {
          path: "/event/nc-visit/terms/:uuid",
          component: TermsAMAZSD133
        },
        {
          path: "/event/2022-IPG-Summer-Institute/terms/:uuid",
          component: EventTermsIPGSummerInstitute2022
        },
        {
          path: "/event/terms/",
          component: EventMissingToken
        },
        {
          path: "/event/missing-token",
          component: EventMissingToken
        },
        {
          path: "/checkin",
          component: EventCheckin,
          meta: {
            auth: true
          }
        },
        {
          path: "/network/stem-network-2024",
          component: STEMNetwork2024
        },
        {
          path: "/event/early-college-summit-2024",
          component: EventEarlyCollegeSummit2024
        },
        {
          path: "/event/early-college-summit-rfp-2024",
          component: EarlyCollegeSummit2024RFP
        },
        {
          path: "/event/early-college-summit-student-speaker-2024",
          component: EarlyCollegeSummit2024StudentSpeaker
        },
        // {
        //   path: "/event/early-college-summit-2025",
        //   component: EarlyCollegeSummit2025
        // },
        // {
        //   path: "/event/early-college-summit-2025-presenter",
        //   component: EarlyCollegeSummit2025Presenter
        // },
        // {
        //   path: "/event/early-college-summit-2025/terms/:uuid?",
        //   component: EarlyCollegeSummit2025Terms
        // },
        {
          path: "/network/early-college-summit-sponsorship-portal-2025",
          component: EarlyCollegeSummitSponsorshipPortal2025
        },
        {
          path: "/network/early-college-summit-sponsorship-portal-2025/terms/:uuid?",
          component: EarlyCollegeSummitSponsorshipPortal2025Terms
        },
        {
          path: "/summit/sponsor",
          component: EarlyCollegeSummitSponsorshipPortal2026
        },
        {
          path: "/network/early-college-summit-sponsorship-portal-2026/terms/:uuid?",
          component: EarlyCollegeSummitSponsorshipPortal2026Terms
        },
        {
          path: "/event/ecs2023/terms/:uuid?",
          component: EventTermsECS2023
        },
        {
          path: "/event/early-college-summit-rfp-2023",
          component: EarlyCollegeSummit2023RFP
        },
        {
          path: "/event/early-college-summit-student-speaker-2023",
          component: EarlyCollegeSummit2023StudentSpeaker
        },
        {
          path: "/event/ecn-student-career-panel-2022",
          component: ECN2022CareerPanel
        },
        {
          path: "/event/ALPS-Fall-2021",
          component: ALPS2021AMAZSD82
        },
        {
          path: "/event/alps-fall-2021",
          component: ALPS2021AMAZSD82
        },
        {
          path: "/event/alps-summer-2023",
          component: ALPS2023
        },
        /** In Person ECN Events */
        {
          path: "/event/ecn-counselor-role-alike-session-2022",
          component: ECNInPersonEvents2021
        },
        {
          path: "/event/ecn-spring-study-visit-2022",
          component: ECNInPersonEvents2021
        },
        {
          path: "/event/ecn-principal-networking-session-2-2021",
          component: ECNInPersonEvents2021
        },
        {
          path: "/event/ecn-principal-networking-session-3-2022",
          component: ECNInPersonEvents2021
        },
        {
          path: "/event/ecn-principal-study-visit-2022",
          component: ECNInPersonEvents2021
        },
        {
          path: "/event/ecn-counselor-networking-session-2022",
          component: ECNInPersonEvents2021
        },
        // RethinkEducationSummerSymposiumPreNetworking2022AMAZSD108
        {
          path: "/event/rethink-summer-symposium-pre-networking-2022",
          component: RethinkEducationSummerSymposiumPreNetworking2022AMAZSD108
        },
        {
          path: "/event/rethink-education-networking-summer-session-1",
          component: RethinkEducationSummerNetworking2022
        },
        {
          path: "/event/rethink-education-networking-summer-session-2",
          component: RethinkEducationSummerNetworking2022
        },
        {
          path: "/event/rethink-education-networking-summer-session-3",
          component: RethinkEducationSummerNetworking2022
        },
        {
          path: "/event/rethink-education-networking-summer-session-4",
          component: RethinkEducationSummerNetworking2022
        },
        {
          path: "/event/rethink-education-networking-summer-session-5",
          component: RethinkEducationSummerNetworking2022
        },
        // ECN Schedule for 2022-2023 that use EventWithSessionOptions.
        {
          path: "/event/ecn-welcome-webinar-2022",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-student-career-panel-public-health-2022",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-student-career-panel-environmental-sciences-2022",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-student-career-panel-human-resources-2023",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-student-career-panel-college-experience-2023",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-fall-student-leader-virtual-networking-session-2022",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-spring-student-leader-virtual-networking-session-2023",
          component: EventWithSessionOptions
        },
        {
          path: "/event/sel-summit-2024",
          component: SELSummit2024
        },
        {
          path: "/event/SEL-Summit-2024",
          component: SELSummit2024
        },
        {
          path: "/event/youth-mental-health-first-aid-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/rti-literacy-summit-literacy-in-nc-2023",
          component: RTILiteracySummit2023
        },
        {
          path: "/event/NC-visit",
          component: NCECSHSStudyVisitAMAZSD133
        },
        {
          path: "/event/nc-visit",
          component: NCECSHSStudyVisitAMAZSD133
        },
        // 2023-2024 ECN Schedule of Events - START.
        {
          path: "/event/ecn-welcome-to-ecn-2023",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-students-game-changer-career-panel-1-fall-2023",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-students-game-changer-career-panel-2-fall-2023",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-students-game-changer-career-panel-3-spring-2024",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-students-game-changer-career-panel-4-spring-2024",
          component: EventWithSessionOptions
        },
        // 2023 ECN Student Leader Networking Sessions
        {
          path: "/event/ecn-student-leader-networking-session-1-fall-2023",
          component: ECNStudentLeaderNetworking
        },
        {
          path: "/event/ecn-student-leader-networking-session-2-spring-2024",
          component: ECNStudentLeaderNetworking
        },
        // ECN Events with Lunch.
        {
          path: "/event/ecn-principals-new-to-network-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-networking-session-1-fall-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-leadership-study-visit-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-regional-networking-session-2a-falleast-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-regional-networking-session-2b-fallwest-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-regional-networking-session-1c-fallwest-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-networking-session-3-spring-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-regional-networking-session-4a-springeast-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-regional-networking-session-4b-springwest-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-networking-session-1-fall-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-regional-networking-session-2a-fallwest-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-regional-networking-session-2b-falleast-2023",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-regional-networking-session-3a-springwest-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-regional-networking-session-3b-springeast-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-networking-session-4-spring-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-falleast-2023",
          component: ECNInnovativePracticeCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-fallwest-2023",
          component: ECNInnovativePracticeCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-springeast-2024",
          component: ECNInnovativePracticeCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-springwest-2024",
          component: ECNInnovativePracticeCustom
        },
        // 2023-2024 ECN Schedule of Events - END.

        // 2024-2025 ECN Schedule of Events - START.
        {
          path: "/event/ecn-welcome-to-ecn-2024",
          component: EventWithSessionOptions
        },
        {
          path: "/event/ecn-principals-new-to-network-2024",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/ecn-principals-networking-session-1-fall-2024",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/ecn-principals-regional-peer-school-review-fall-east-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-regional-peer-school-review-fall-west-2024",
          component: DietaryRestrictionsCustom
        },
        // No custom template for this event.
        // { path: '/event/ecn-principals-networking-session-2-fall-2024', component: DietaryRestrictionsCustom },
        {
          path: "/event/ecn-principals-networking-session-3-spring-2025",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        // No custom template for this event.
        // { path: '/event/ecn-principals-networking-session-4-spring-2025', component: DietaryRestrictionsCustom },
        {
          path: "/event/ecn-principals-regional-peer-school-review-spring-east-2025",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-principals-regional-peer-school-review-spring-west-2025",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-networking-session-1-fall-2024",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/ecn-counselors-regional-networking-session-fall-east-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-regional-networking-session-fall-west-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-networking-session-2-spring-2025",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/ecn-counselors-regional-networking-session-spring-west-2025",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-counselors-regional-networking-session-spring-east-2025",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-fall-east-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-fall-west-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-spring-east-2025",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-spring-west-2025",
          component: DietaryRestrictionsCustom
        },
        // { path: '/event/ecn-instructional-design-workshop-followup-spring-2025', component: DietaryRestrictionsCustom },
        {
          path: "/event/ecn-instructional-design-workshop-fall-east-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-instructional-design-workshop-fall-west-2024",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-students-game-changer-career-panel-1-fall-2024",
          component: ECN2024StudentGameChangerCareerPanel
        },
        {
          path: "/event/ecn-students-game-changer-career-panel-2-spring-2025",
          component: ECN2024StudentGameChangerCareerPanel
        },
        {
          path: "/event/ecn-student-leader-networking-session-1-fall-2024",
          component: ECNStudentLeaderNetworking
        },
        {
          path: "/event/ecn-student-leader-networking-session-2-spring-2025",
          component: ECNStudentLeaderNetworking
        },

        // 2024-2025 ECN Schedule of Events - END.

        // 2025-2026 ECN Schedule of Events - START.
        {
          path: "/event/2025-virtual-early-college-network-kickoff",
          component: EventWithSessionOptions
        },
        {
          path: "/event/2026-virtual-early-college-network-kickoff",
          component: EventWithSessionOptions
        },

        {
          path: "/event/new-to-the-ecn-principals-session",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/2026-new-to-the-ecn-principals-session",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },

        {
          path: "/event/fall-statewide-ecn-leadership-session-at-rti",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/2026-fall-statewide-ecn-leadership-session-at-rti",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },

        {
          path: "/event/spring-statewide-ecn-leadership-session-at-rti",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/2027-spring-statewide-ecn-leadership-session-at-rti",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/virtual-ecn-leadership-session-for-principals-october",
          component: EventVirtual
        },
        // No custom template for this event.
        // { path: '/event/ecn-principals-networking-session-2-fall-2024', component: DietaryRestrictionsCustom },
        {
          path: "/event/virtual-ecn-leadership-session-for-principals-november",
          component: EventVirtual
        },
        {
          path: '/event/monthly-virtual-ecn-leadership-session-for-principals',
          component: EventTextOnly
        },
        // No custom template for this event.
        // { path: '/event/ecn-principals-networking-session-4-spring-2025', component: DietaryRestrictionsCustom },
        {
          path: "/event/virtual-ecn-leadership-session-for-principals-january",
          component: EventVirtual
        },
        {
          path: "/event/virtual-ecn-leadership-session-for-principals-march",
          component: EventVirtual
        },
        {
          path: "/event/fall-regional-ecn-leadership-site-visit-east",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/fall-regional-ecn-leadership-site-visit-central",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/fall-regional-ecn-leadership-site-visit-west",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/spring-regional-ecn-leadership-site-visit-east",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/spring-regional-ecn-leadership-site-visit-west",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/fall-statewide-ecn-session-for-counselors-college-liaisons-at-rti",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/2026-fall-statewide-ecn-session-for-counselors-college-liaisons-at-rti",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/spring-statewide-ecn-session-for-counselors-college-liaisons-at-rti",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: "/event/2027-spring-statewide-ecn-session-for-counselors-college-liaisons-at-rti",
          component: EventWithSessionOptionsAndDietaryRestrictions
        },
        {
          path: '/event/monthly-virtual-ecn-session-for-counselors-college-liaisons',
          component: EventTextOnly
        },
        {
          path: "/event/virtual-ecn-session-for-counselors-college-liaisons-november",
          component: EventVirtual
        },
        {
          path: "/event/virtual-ecn-session-for-counselors-college-liaisons-december",
          component: EventVirtual
        },
        {
          path: "/event/virtual-ecn-session-for-counselors-college-liaisons-february",
          component: EventVirtual
        },
        // { path: '/event/ecn-instructional-design-workshop-followup-spring-2025', component: DietaryRestrictionsCustom },
        {
          path: "/event/virtual-ecn-session-for-counselors-college-liaisons-april",
          component: EventVirtual
        },
        {
          path: "/event/fall-regional-ecn-session-for-counselor-college-liaisons-east",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/fall-regional-ecn-session-for-counselor-college-liaisons-west",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/spring-regional-ecn-session-for-counselors-college-liaisons-east",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/spring-regional-ecn-session-for-counselors-college-liaisons-west",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-east",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-central",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-innovative-practice-study-visit-west",
          component: DietaryRestrictionsCustom
        },
        {
          path: "/event/ecn-innovative-practice-virtual-workshop-student-centered-learning-practices",
          component: EventVirtual
        },
        {
          path: "/event/ecn-innovative-practice-virtual-workshop-integrated-artificial-intelligence-ai-into-instruction",
          component: EventVirtual
        },
        {
          path: "/event/ecn-innovative-practice-virtual-workshop-supporting-first-generation-students",
          component: EventVirtual
        },
        {
          path: "/event/ecn-innovative-practice-virtual-workshop-supporting-multilingual-learners",
          component: EventVirtual
        },
        {
          path: "/event/fall-game-changer-virtual-career-panel-for-ecn-students",
          component: EventVirtual
        },
        {
          path: "/event/spring-game-changer-virtual-career-panel-for-ecn-students",
          component: EventVirtual
        },
        {
          path: "/event/virtual-fall-college-career-readiness-development-for-ecn-students",
          component: EventVirtual
        },
        {
          path: "/event/virtual-spring-college-career-readiness-development-for-ecn-students",
          component: EventVirtual
        },
        {
          path: "/event/ecn-alike-communities",
          component: EventCoP
        },
        {
          path: "/event/virtual-ecn-session-core-practices-for-rigorous-engaging-instruction",
          component: EventVirtual
        },
        {
          path: "/event/virtual-ecn-session-integrating-ai-across-curriculum",
          component: EventVirtual
        },
        {
          path: "/event/virtual-ecn-session-supporting-multilingual-learners",
          component: EventVirtual
        },
        {
          path: "/event/virtual-ecn-session-making-work-based-learning-work",
          component: EventVirtual
        },

        // 2025-26 ECN END

        // DietaryRestrictionsCustom
        {
          path: "/event/new-teacher-institute-2024",
          component: NewTeacherInstitute
        },
        {
          path: "/event/new-teacher-institute-2024/terms/:uuid?",
          component: NewTeacherInstituteTerms
        },
        // PreConferenceStudyVisit2024
        {
          path: "/event/pre-conference-study-visit-2024",
          component: PreConferenceStudyVisit2024
        },
        {
          path: "/event/pre-conference-study-visit-2024/terms/:uuid?",
          component: PreConferenceStudyVisitTerms2024
        },
        {
          path: "/event/pre-conference-study-visit-2025",
          component: PreConferenceStudyVisit2025
        },
        {
          path: "/event/pre-conference-study-visit-2025/terms/:uuid?",
          component: PreConferenceStudyVisitTerms2025
        },
        {
          path: "/event/leading-through-change-nc-science-standards",
          component: TextBasedRole
        }
      ]
    },
    {
      path: "",
      component: LayoutEducationServices,
      children: [
        {
          path: "event/list",
          name: "Event",
          component: EventsList
        }
      ]
    },
    // Dynamic routing for event registrations (event landing pages).
    // This route MUST be placed after the original event routing code
    // so that events which existed before this was implemented and
    // customized event pages will still work.
    {
      path: "",
      component: LayoutEducationServices,
      children: [
        // Dynamic Event Routing.
        {
          path: "event/:slug",
          name: "Event",
          component: Event
        }
      ]
    },
    // Dynamic routing for network registrations.
    {
      path: "",
      component: LayoutEducationServices,
      children: [
        {
          path: "network/checkin",
          // component: NetworkCheckin,
          component: SharedCheckin,
          meta: {
            auth: true,
            checkin: "network"
          }
        },
        {
          path: "network/aspire-teacher-prep-2020",
          component: NetworkAspireTeacherPrep2020
        },
        {
          path: "network/aspire-teacher-prep-2023",
          component: NetworkAspireTeacherPrep2023
        },
        {
          path: "network/ncld-math-science-collaborative-2021",
          component: NCLDMathScienceCollaborative2021
        },
        {
          path: "network/ncld-math-science-collaborative-2022",
          component: NCLDMathScienceCollaborative2022
        },
        {
          path: "network/ncldc-2022",
          component: NCLDC2022
        },
        {
          path: "network/ncldc-2023",
          component: NCLDC2023
        },
        {
          path: "network/ncldc-2024",
          component: NCLDC2024
        },
        {
          path: "network/ncldc-2025",
          component: NCLDC2025
        },
        {
          path: "network/ncldc-2026",
          component: NCLDC2026
        },
        {
          path: "network/llin-2026",
          component: LLIN2026
        },
        {
          path: "network/early-college-network-2023",
          component: ECN2023
        },
        {
          path: "network/early-college-network-2024",
          component: ECN2024
        },
        {
          path: "network/early-college-network-2025",
          component: ECN2025
        },
        {
          path: "network/early-college-network-2026",
          component: ECN2026
        },
        {
          path: "network/national-early-college-leaders-network-2024",
          component: NationalECN2024
        },
        {
          path: "network/national-early-college-leaders-network-2026",
          component: NationalECLN2026
        },
        {
          path: "network/early-college-network-half-year-2024",
          component: ECNHalfYear2024
        },
        {
          path: "network/early-college-network-half-year-2025",
          component: ECNHalfYear2025
        },
        {
          path: "network/early-college-network-half-year-2026",
          component: ECNHalfYear2026
        },
        {
          path: "network/msdln-2023",
          component: MSDLN2023
        },
        {
          path: "network/msdln-2024",
          component: MSDLN2024
        },
        {
          path: "network/msdln-2025",
          component: MSDLN2025
        },
        {
          path: "network/msdln-2026",
          component: MSDLN2026
        },
        // Dynamic Network Routing.
        {
          path: "network/:slug",
          name: "Network",
          component: Network
        }
      ]
    },
    {
      path: "",
      component: LayoutLogin,
      children: [
        // error pages
        {
          path: "/403",
          component: error403
        },
        {
          path: "/404",
          component: error404
        },
        {
          path: "/500",
          component: error500
        },
        {
          path: "*",
          component: error404
        }
      ]
    }
  ]
});

const newUserAccountGuard = (function (router) {
  // For best accuracy, we would actually need to perform an auth fetch here, however,
  // for the sake of performance and scalability, we'll skip that step. However,
  // if the auth user information has changed at some point and isn't manually reloaded
  // it's possible the information used here will be stale.
  function isAuthPath(to) {
    return to.meta.hasOwnProperty("auth") && to.meta.auth;
  }

  // 2022-06-20: The user profile update was pushed to master before it was
  // entirely ready for prime time. For now, I'll disable this forced
  // terms and profile update stuff to give users and developers a break.
  const steps = [
    /**
    {
      path: '/terms',
      trigger: function(to, from) {
        return !Vue.auth.user().tos_ack
      }
    },
    {
      path: '/profile/edit',
      trigger: function(to, from) {
        // We need this to run once per login, basically if the user skips
        // the profile info step, that's okay, but we need to remind/request
        // on each new login until it's filled out.
        if ((from.name && from.name === "Login") || (to.name && to.name === "Logout")) {
          localStorage.setItem('profile_commenced', false);
        }

        // Check if profile commenced, and be sure to only ask once per login.
        var runonce = JSON.parse(localStorage.getItem('profile_commenced'));
        var triggered = Vue.auth.user().profile_commenced !== true && !runonce;

        localStorage.setItem('profile_commenced', true);

        return triggered;
      }
    }  */
  ];

  // The idea here is that if there's auth meta, then the route we're
  // navigating to is behind an authentication wall. (NOTE: This assumption
  // may not always be correct, but for the intent of this application
  // as it is currently implemented, this applies.) If we're navigating
  // to a route that needs authentication, then we double check to ensure
  // that the user has performed the appropriate steps.
  // If the user has, then we go on, otherwise we intercept
  // and force them to jump through our hoops (i.e. tos, profile, etc).
  return function (to, from, next) {
    for (var i = 0; i < steps.length; i++) {
      if (isAuthPath(to)) {
        var step = steps[i];
        if (step.trigger(to, from)) {
          if (to.path !== step.path) {
            console.log("next path " + step.path);
            next({ path: step.path });
            return;
          } else {
            next();
            return;
          }
        }
      }
    }
    next();
  };
})(router);

router.beforeResolve(multiguard([newUserAccountGuard]));

export default router;
